<template>
  <q-select
    :value="value"
    v-bind="$attrs"
    label="Type"
    option-value="value"
    option-label="label"
    emit-value
    map-options
    :options="$options.CUSTOMERS_TYPE_LIST"
    v-on="$listeners"
  />
</template>

<script>
import { CUSTOMERS_TYPE_LIST } from '@/consts/customers'
import validateProxyMixin from '@/mixins/validateProxyMixin'

export default {
  name: 'SelectCustomerType',
  mixins: [validateProxyMixin],
  inheritAttrs: false,
  CUSTOMERS_TYPE_LIST,
  props: {
    value: {
      type: [Array, Object, String, Number],
      default: _.stubObject
    }
  }
}
</script>

<style scoped>

</style>
